export default {"src":"/_next/static/media/medium.decc782d.svg","height":20,"width":20};